exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "li.display-flex {\n  display: flex;\n  display: -ms-flexbox; }\n\nul.location-sequence {\n  list-style-type: none; }\n\nli.dndPlaceholder {\n  background: #eee;\n  height: 50px; }\n\n.dt {\n  padding: 8px; }\n\n.div-table {\n  width: 99%;\n  max-width: 99%;\n  display: table;\n  margin-top: 5px; }\n\n.div-tr {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-bottom-width: 2px; }\n\n.div-td {\n  border-left: 1px solid #ddd;\n  padding-left: 0px !important;\n  padding-right: 0px !important; }\n\n.border-right {\n  border-right: 1px solid #ddd; }\n\n.border-bottom {\n  border-bottom: 1px solid #ddd; }\n\n.new-btn {\n  float: right;\n  margin: 4px 12px; }\n\n.col-width-18 {\n  width: 18% !important; }\n\n.col-width-32 {\n  width: 32% !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/location/common/deliver_location/deliver_location.scss
// module id = 1048
// module chunks = 1